class ProductRecommendations extends HTMLElement {
  section = this.closest('section');
  swiperElement = this.querySelector('[data-swiper]');
  slides = [];

  connectedCallback() {
    this.init();
  }

  async init() {
    const html = await this.fetchHTML();
    const slides = html.querySelectorAll('.swiper-slide');

    if (slides.length === 0) return;

    this.slides = slides;

    await this.initSwiper();
    this.section.classList.remove('hidden');
  }

  async initSwiper() {
    if (!this.swiperElement) return;

    const { Swiper } = await import('swiper');
    const { A11y, Navigation, Manipulation } = await import('swiper/modules');
    const dataOptions = JSON.parse(this.swiperElement.dataset?.options || '{}');

    this.swiperInstance = new Swiper(this.swiperElement, {
      modules: [A11y, Navigation, Manipulation],
      threshold: 10,
      loop: false,
      autoplay: false,
      direction: 'horizontal',
      slidesPerView: 1.05,
      spaceBetween: 8,
      breakpoints: {
        480: {
          slidesPerView: 2.2,
          spaceBetween: 8,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 12,
        },
      },
      ...dataOptions,
    });

    this.swiperInstance.appendSlide(this.slides);
  }

  async fetchHTML() {
    try {
      const response = await fetch(this.dataset.url);
      const text = await response.text();
      return new DOMParser().parseFromString(text, 'text/html');
    } catch (error) {
      console.error('Error loading product recommendations:', error);
    }
  }
}

customElements.define('product-recommendations', ProductRecommendations);
